var React = require('react');

function FacebookFBrands (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m215.8 85h48.2v-81.4c-8.3-1.1-36.9-3.6-70.2-3.6-69.5 0-117.1 42.4-117.1 120.3v71.7h-76.7v91h76.7v229h94v-229h73.6l11.7-91h-85.3v-62.7c0-26.3 7.3-44.3 45.1-44.3z"}));
}

FacebookFBrands.defaultProps = {"viewBox":"0 0 264 512"};

module.exports = FacebookFBrands;

FacebookFBrands.default = FacebookFBrands;
